(function(angular){
	'use strict';

	angular
		.module('videoModule')
		.directive('video', [
			'$timeout',
			videoFunction
		]);

	function videoFunction($timeout) {
		return {
			restrict: 'E',
			link: {
				pre: function($scope, $elem) {
					$elem.addClass('fade');
				},
				post: function($scope, $elem) {

					function fadeInAndPlay() {
						$timeout(function() {
							$elem.addClass('in');
						}, 250);
						$timeout(function() {
							$elem[0].play();
						}, 500);
					}

					if($elem[0].readyState === 4) {
						fadeInAndPlay();
					} else {
						$elem[0].oncanplaythrough = function() {
							fadeInAndPlay();
						};
					}
				}
			}
		};
	}
})(window.angular);